// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "./Box.res.js";
import * as React from "react";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stylex from "@stylexjs/stylex";
import * as CanaryPageHeader from "./CanaryPageHeader.res.js";
import * as JsxRuntime from "react/jsx-runtime";
let make = React.memo(props => {
  let match = {
    className: "backgroundColor-x150bj9m borderLeftColor-x1qlbgvd borderLeftStyle-x19ypqd9 borderLeftWidth-xe0pwq display-x78zum5 flex-x98rzlu flexDirection-xdt5ytf height-x5yr21d overflow-xysyzu8 position-x1n2onr6 zIndex-x1vjfegm",
    "data-style-src": "wino-gc:src/resources/layout-and-structure/NextPage.res.js:11"
  };
  let domRef = Stdlib_Option.map(props.rootRef, prim => prim);
  return JsxRuntime.jsx("div", {
    children: props.children,
    ref: domRef,
    className: match.className,
    style: match.style
  });
});
function NextPage(props) {
  let match = React.useState(() => false);
  let setScrolled = match[1];
  let layoutRef = React.useRef(null);
  React.useLayoutEffect(() => {
    let handler = param => {
      let el = layoutRef.current;
      if (!(el == null)) {
        return setScrolled(param => el.scrollTop > 0);
      }
    };
    handler();
    let el = layoutRef.current;
    if (!(el == null)) {
      el.addEventListener("scroll", handler);
      return () => {
        el.removeEventListener("scroll", handler);
      };
    }
  }, []);
  return JsxRuntime.jsxs(make, {
    children: [JsxRuntime.jsx(CanaryPageHeader.make, {
      title: props.title,
      titlePrepender: props.titlePrepender,
      subtitle: props.subtitle,
      subtitleBadgeElement: props.subtitleBadgeElement,
      mainActionsElement: props.mainActionsElement,
      scrolled: match[0],
      onRequestGoBack: props.onRequestGoBack
    }), JsxRuntime.jsx(Box.make, {
      children: props.children,
      spaceX: "large",
      spaceY: "xlarge"
    })],
    rootRef: layoutRef
  });
}
let make$1 = React.memo(NextPage);
export { make$1 as make };
/* styles Not a pure module */